/**
 * @desc 查询矿化剂需求周计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekMineralizerResponse>> {
  return defHttp.post({
    url: '/wap/plan/week/queryPlanMineralizer',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekMineralizerResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/week/queryPlanMineralizer',
    data,
  });
}
